import React, { useContext, useMemo } from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box"; 
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";  
import { UserContext } from "../../../../../platform/components/auth/auth-context";
import BookingTypeHome from "./bookingTypeHome";
import { useNavigate, useParams } from "react-router-dom";

const TOUR_ONLY_BOOKING_TYPE_KEYWORDS = ["tour", "visit", "walkthrough"];

function isTourOnlyConciergeBookingType(bookingType) {
  if (!bookingType?.createdByAgentId) return false;

  const title = String(bookingType?.title || "").toLowerCase();
  const link = String(bookingType?.link || "").toLowerCase();

  return TOUR_ONLY_BOOKING_TYPE_KEYWORDS.some(
    (keyword) => title.includes(keyword) || link.includes(keyword)
  );
}

const ColorButton = styled((props) => <Button variant="outlined" {...props} />)({
  height: "50px",
  border: "none",
  "&:hover": {
    border: "none", 
  },
});
 
const BookingTypeEntryFormHeader = (props) => {
  const userContext = useContext(UserContext);
  const providerUser = userContext.providerUser; 
  const DisplayComponent = props.display || BookingTypeHome;
  const navigate = useNavigate();
  const { id } = useParams();
  const currentBookingType = useMemo(
    () => (Array.isArray(props?.data) ? props.data.find((item) => Number(item?.id) === Number(id)) : null),
    [props?.data, id]
  );
  const fallbackBackHref = isTourOnlyConciergeBookingType(currentBookingType)
    ? "/biz/dashboard"
    : "/biz/bookingtypes";
  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate(fallbackBackHref);
  };

  return (
    <Box> 
      <Box sx={{ width: "100%", overflowY: "auto" }}>
        <ColorButton
          onClick={handleBack}
          startIcon={<ChevronLeftIcon />}
        >
          Back
        </ColorButton>
        <DisplayComponent
          {...props}
          currentStaffId={providerUser.staffId}
          providerUser={providerUser}
          details={providerUser}
        />
      </Box>
    </Box>
  );
};

export default BookingTypeEntryFormHeader;
